//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AQDropdownBadge from "../../../../../components/Generics/AQDropdownBadge/AQDropdownBadge.vue";

export default {
    components: {
        "a-q-dropdownbadge": AQDropdownBadge
    },
    data() {
        return {
            dropdownList: [
                {
                    value: "mod",
                    button: "mod"
                },
                {
                    value: "date",
                    button: "date"
                },
                {
                    value: "time",
                    button: "time"
                },
                {
                    value: "datetime",
                    button: "dtm"
                },
                {
                    value: "logical",
                    button: "log"
                },
                {
                    value: "txt",
                    button: "txt"
                }
            ],
            badge: "",
            badgeSelected:
                {
                    value: "mod",
                    button: "mod"
                }
        };
    },
    methods: {
        selectedBadge(event) {
            console.log(event);
            this.badge = event;
        }
    }
};
